import { EncryptAES, DecryptAES, GenerateHex } from "./crypto";

function SetOrder(items) {
  if (items === null) return;
  let tk = LoadCookie("_gtk");
  if (tk === undefined) {
    tk = GenerateHex();
    SetCookie("_gtk", tk);
  }
  if (items.menu)
    localStorage.setItem("_lo", EncryptAES(JSON.stringify(items), tk));

  return;
}

function LoadOrder(id) {
  let empty = { menu: id, total: 0, details: [] };
  try {
    let tk = LoadCookie("_gtk");
    let det = null;
    
    if ((localStorage.getItem("_lo") !== null) & (tk !== undefined))
      det = JSON.parse(DecryptAES(localStorage.getItem("_lo"), tk));
    return det !== null ? (det.menu === id ? det : empty) : empty;
  } catch (err) {
    return empty;
  }
}

function SetInfo(items) {
  // if (items === null) return;
  let tk = LoadCookie("_gtk");
  if (tk === undefined) {
    tk = GenerateHex();
    SetCookie("_gtk", tk);
  }
  if (items.id)
    localStorage.setItem("_li", EncryptAES(JSON.stringify(items), tk));
  return;
}

function LoadInfo() {
  let empty = {};
  try {
    let tk = LoadCookie("_gtk");
    let info = null;
    
    if ((localStorage.getItem("_li") !== null) & (tk !== undefined))
      info = JSON.parse(DecryptAES(localStorage.getItem("_li"), tk));
    return info !== null ? info : empty;
  } catch (err) {
    return empty;
  }
}

function SetLang(lang) {
  SetCookie("lang", lang);
}

function LoadLang(lang) {
  var l = LoadCookie("lang");
  if (l) return l;
  else return "";
}

function SetCookie(name, value) {
  $cookies.set(name, value, "30d");
  return;
}

function LoadCookie(name) {
  if ($cookies === undefined) return;
  if ($cookies.isKey(name)) return $cookies.get(name);
}

function SaveStatePlugin(store) {
  store.subscribe((mutation, state) => {
    SetLang(state.lang);
    SetOrder(state.order);
    SetInfo(state.info);
  });
}

export {
  SetCookie,
  LoadCookie,
  SaveStatePlugin,
  LoadLang,
  LoadOrder,
  LoadInfo,
};
